<template>
	<div id="mainpage" class="flex flex-col min-h-screen home wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}">

		<SiteHeader />


		<section class="section banner-section relative lg:h-0 lg:min-h-[900px] X__parallax z-[1]">
			<!-- <img class="absolute top-0 left-0 object-cover object-[60%] w-full h-auto pointer-events-none lg:object-top parallax-bg X__-skew-y-6" src="@/assets/img/banner-bg.jpg" alt="" width="756" height="567" :style="{top: `${winScrollY.global}px`}"> -->
			<div class="absolute -top-32 left-0 w-full bottom-0 skew-y-6 X__bg-white pointer-events-none overflow-hidden X__parallax">
				<img class="absolute top-32 left-0 object-cover object-[60%] w-full h-full lg:h-auto pointer-events-none lg:object-top X__parallax-bg -skew-y-6" src="@/assets/img/banner-bg02.jpg" alt="" width="1920" height="1080" :style="{top: `${winScrollY.banner}px`}">
			</div>
			<!-- <div class="X__bg-gradient-to-r bg-[#0008] lg:bg-transparent X__lg:from-[#244D13C0] w-full lg:w-10/12 h-[150%] absolute top-0 left-0 pointer-events-none"></div> -->
			<div class="container relative h-full mt-48 lg:mt-0">
				<div class="flex items-center h-full">
					<div class="flex lg:justify-end">
						<div class="flex flex-wrap w-full lg:w-10/12 relative pb-8 lg:py-12 lg:gap-y-4 lg:justify-end">
							<div class="absolute hidden lg:block inset-0 right-1/2 pointer-events-none bg-gradient-to-l from-[#244D13C0]"></div>
							<div class="absolute hidden lg:block inset-0 left-1/2 pointer-events-none bg-[#E8D716]"></div>
							<div class="flex flex-wrap relative w-full gap-y-4 bg-gradient-to-t from-[#244D13F0] lg:bg-none pt-16 pb-4 lg:py-0 -mt-8 lg:mt-0">
								<div class="w-full lg:w-1/2 px-4 lg:px-8 text-center lg:text-right text-white">
									<div class="text-4xl font-semibold uppercase font-oswald lg:text-6xl lg:leading-tight">
										A Piece of Art <span class="inline-block font-extralight">Under Your Feet.</span>
									</div>
								</div>
								<div class="w-full lg:w-1/2 px-4 lg:px-8 text-center lg:text-left text-white lg:text-[#2B2B2B]">
									<div class="text-4xl font-semibold uppercase font-oswald lg:text-6xl lg:leading-tight">
										<span class="inline-block font-extralight">We Are The Guys</span> <span class="inline-block">You Need!</span>
									</div>
								</div>
							</div>
							<div class="flex flex-wrap relative w-full gap-y-4 bg-[#E8D716] lg:bg-transparent pt-4 pb-6 lg:py-0">
								<div class="w-full lg:w-1/2 px-6 lg:px-8 text-justify lg:text-right text-[#2B2B2B] lg:text-white">
									<p>
										We deliver a complete quality wood works in sash, flooring, ceiling, wall and other interior and architectural accent that is done systematically by an expert.
									</p>
								</div>
								<div class="w-full lg:w-1/2 px-4 lg:px-8 text-left text-[#2B2B2B] space-y-6">
									<ul class="pl-4 list-['✔']">
										<li class="pl-3">Nail-Less Wood Flooring Installation</li>
										<li class="pl-3">Special Sanding for Premium Finish</li>
										<li class="pl-3">Professional Workmanship</li>
									</ul>
									<a href="#inquiry" v-smooth-scroll class="justify-self-center mx-auto lg:mx-0 border border-[#2B2B2B] hover:border-white hover:bg-white duration-200 w-[210px] h-[44px] lg:h-[50px] flex items-center justify-center rounded-full">
										Send Us A Message
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="relative section products-section z-[1]">
			<div class="absolute top-0 left-0 w-full h-full skew-y-6 X__bg-white pointer-events-none">
				<div class="absolute top-0 left-0 right-0 h-36 bg-white"></div>
				<!-- <div class="absolute inset-0 top-16 lg:top-32 bg-[#E8D716] overflow-hidden">
					<div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}"></div>
					<div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg-3 mix-blend-darken opacity-20"></div>
				</div> -->
			</div>
			<div class="container relative pb-15 lg:pb-32 lg:-top-12 space-y-8 lg:space-y-12">
				<div class="">
					<iframe class="mx-auto w-full lg:w-9/12 h-auto" style="aspect-ratio:16/9" width="560" height="315" src="https://www.youtube-nocookie.com/embed/c5QtIvTWEHo?si=QRcnSUkLNicgg8_G" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
				</div>
				<div class="lg:flex bg-white shadow-md">
					<div class="flex justify-center lg:justify-start items-center text-3xl lg:text-5xl lg:leading-tight text-white bg-[#244D13] font-oswald p-4 text-right">
						<div>
							<span class="lg:block font-extralight">Our</span> Services
						</div>
					</div>
					<div class="flex items-center p-4">
						<ul class="grid-cols-3 list-disc lg:grid">
							<li class="ml-6">Wooden Flooring</li>
							<li class="ml-6">Wooden Doors & Jambs</li>
							<li class="ml-6">Wooden Stairs, Handrails & Balusters</li>
							<li class="ml-6">Wooden Ceiling & Wall Panel</li>
							<li class="ml-6">Narra Parquet </li>
							<li class="ml-6">Solid Wood Planks</li>
							<li class="ml-6">Teakwood Planks</li>
							<li class="ml-6">Sash Works</li>
							<li class="ml-6">Sanding Services</li>
							<li class="ml-6">Varnishing Works</li>
							<!-- <li class="ml-6">Fit-Out Works</li> -->
							<li class="ml-6">Solid Wood Kitchen Cabinets</li>
						</ul>
					</div>
				</div>

				<div class="mt-16 lg:mt-24 space-y-8 lg:space-y-12">
					<div class="text-3xl text-center lg:text-5xl lg:leading-tight font-oswald">
						<span class="font-extralight">Our</span> Products
					</div>
					<!-- <div class="grid gap-8 lg:grid-cols-3">
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-flooring.jpg" alt="" width="420" height="315">
							<div class="font-bold">Wooden Flooring</div>
						</div>
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-stairs.jpg" alt="" width="420" height="315">
							<div class="font-bold">Wooden Stairs</div>
						</div>
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-ceilingwall.jpg" alt="" width="420" height="315">
							<div class="font-bold">Wooden Ceiling & Wall Panels</div>
						</div>
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-door.jpg" alt="" width="420" height="315">
							<div class="font-bold">Wooden Door</div>
						</div>
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-sashworks.jpg" alt="" width="420" height="315">
							<div class="font-bold">Sash Works</div>
						</div>
						<div class="text-center space-y-2">
							<img class="w-full h-auto" src="@/assets/img/product-interiors.jpg" alt="" width="420" height="315">
							<div class="font-bold">Wood Interiors Sanding & Varnishing</div>
						</div>
					</div> -->
					<div class="grid gap-12">
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center">
								<div class="hidden lg:block w-full"></div>
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Wooden Flooring</div>
								<hr class="hidden lg:block w-full border-white border-t-2">
							</div>
							<div class="lg:col-span-2 bg-white p-2 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-flooring04.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-flooring05.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-flooring01.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center lg:order-2">
								<hr class="hidden lg:block w-full border-white border-t-2">
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Wooden Stairs</div>
								<div class="hidden lg:block w-full"></div>
							</div>
							<div class="lg:col-span-2 bg-white p-2 lg:order-1 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-stairs01.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-stairs02.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-stairs03.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-stairs04.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center">
								<div class="hidden lg:block w-full"></div>
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Wooden Ceiling<br>and Wall Cladding</div>
								<hr class="hidden lg:block w-full border-white border-t-2">
							</div>
							<div class="lg:col-span-2 bg-white p-2 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-ceilingwall01.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-ceilingwall02.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-ceilingwall03.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center lg:order-2">
								<hr class="hidden lg:block w-full border-white border-t-2">
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Wooden Door</div>
								<div class="hidden lg:block w-full"></div>
							</div>
							<div class="lg:col-span-2 bg-white p-2 lg:order-1 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-door01.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-door02.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-door04.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-door05.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center">
								<div class="hidden lg:block w-full"></div>
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Wooden Cabinets</div>
								<hr class="hidden lg:block w-full border-white border-t-2">
							</div>
							<div class="lg:col-span-2 bg-white p-2 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-cabinets01.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-cabinets02.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-cabinets03.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>
						<div class="grid gap-y-4 lg:gap-y-8 lg:grid-cols-3">
							<div class="flex items-center justify-center lg:order-2">
								<hr class="hidden lg:block w-full border-white border-t-2">
								<div class="border-white border rounded-full px-4 bg-white py-1 flex-none text-center font-bold text-xl lg:text-2xl">Sash Work</div>
								<div class="hidden lg:block w-full"></div>
							</div>
							<div class="lg:col-span-2 bg-white p-2 lg:order-1 overflow-hidden">
								<owl-carousel
									class=""
									:dots="true"
									:nav="false"
									:loop="true"
									:autoplay="true"
									:autoHeight="false"
									:autoplayTimeout="5000"
									:touchDrag="true"
									:mouseDrag="true"
									:margin="8"
									:responsive="{
										0: {items: 1},
										1024: {items: 2},
									}"
								>
									<div class="">
										<img class="" src="@/assets/img/product-sashwork01.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-sashwork02.jpg" alt="" width="420" height="315">
									</div>
									<div class="">
										<img class="" src="@/assets/img/product-sashwork03.jpg" alt="" width="420" height="315">
									</div>
								</owl-carousel>
							</div>
						</div>

					</div>
				</div>

			</div>
		</section>


		<section class="relative section woods-section z-[1]">
			<!-- <div class="absolute top-0 left-0 w-full h-full skew-y-6 pointer-events-none">
				<div class="absolute inset-0 X__bottom-16 X__lg:bottom-32 X__bg-[#E8D716] overflow-hidden">
					<div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}"></div>
				</div>
			</div> -->
			<div class="container relative pb-8 X__lg:pb-48 lg:-top-12">
				<div class="space-y-12">
					<div class="text-3xl text-center lg:text-5xl lg:leading-tight font-oswald">
						<span class="font-extralight">List of</span> Woods Offered
					</div>
					<div class="lg:px-[55px]">
						<div class="shadow-lg">
							<owl-carousel
								class="woods-slider relative max-w-[1138px] bg-white lg:bg-transparent"
								:nav="false"
								:loop="true"
								:autoplay="true"
								:autoHeight="false"
								:autoplayTimeout="5000"
								:touchDrag="true"
								:mouseDrag="true"
								:margin="0"
								:items="1"
								:responsive="{
									0: {dots:true},
									1024: {dots:false},
								}"
							>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-azobe.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Azobe
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Azobe is firm and heavy, being amongst the hardest usable woods in the world, and is largely impervious to the effects of insects and weather. These qualities make it a first-class construction timber with tremendous longevity. However, drying must be done slowly, and at low temperature, to avoid breakage or distortions. Examples of azobe's many uses are bridge construction, the building of railway sleepers and freight cars, and vehicle construction. In addition, it is used for wood decking, heavy lumber beams, and the production of laboratory furniture.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-ipil.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Ipil
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Ipil (Intsia bijuga (Colebr.) Kuntze). Ipil is a lowland rainforest tree that grows up to 45 meters. The tree has prominent buttresses when mature. It is commonly found along the coasts and occasionally, on low hills. Ipil produces one of the most valuable timbers in southeast Asia.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-movingui.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Movingui
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">The exotic species movingui is a lemon yellow to yellow brown wood. It is a medium-heavy, medium-hard to hard wood. It does not require preservative treatment against dry wood borers, however it may need to be treated if there is a risk of temporary moistening.</p>
									</div>
								</div>
								<!-- <div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-narra-amarillo.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Narra Amarillo
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Also called asana, padauk, mukwa, Burmese rosewood, or Andaman redwood, genus of timber trees of the pea family (Fabaceae), native to Asia and Africa. Narra wood is primarily used for cabinetwork; it is usually red or rose colour, often variegated with yellow. The wood is hard and heavy, and the pattern of the grain and the colouring are hardly equaled by any other timber. The name refers especially to Pterocarpus indicus, or India padauk, noted for the ability of its wood to take a high polish.</p>
									</div>
								</div> -->
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-narra-yellowish.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Narra (Rosewood)
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Also called asana, padauk, mukwa, Burmese rosewood, or Andaman redwood, genus of timber trees of the pea family (Fabaceae), native to Asia and Africa. Narra wood is primarily used for cabinetwork; it is usually red or rose colour, often variegated with yellow. The wood is hard and heavy, and the pattern of the grain and the colouring are hardly equaled by any other timber. The name refers especially to Pterocarpus indicus, or India padauk, noted for the ability of its wood to take a high polish.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-oakwood.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Oak Wood
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Oak wood is a type of hardwood that derives from the oak tree native to the northern hemisphere. There are around 600 species of oak, both deciduous and evergreen. North America has the most, with around 90 species being found there. Oak wood has been used as a hardwood timber for thousands of years, yet it takes up to 150 years before the wood from an oak tree can be used for construction. Modern uses for oak wood include homewares, flooring, wine barrels, and firewood.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-okoume.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Okoume
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Okoume is one of the main exotic timber species exploited in the Congo basin. Offering a relatively uniform appearance and tones ranging from light red to red brown, okoume timber is widely used in the manufacture of plywood, and also to make furniture, moulding, and panelling. Okoume timber is a very light to light exotic wood, very soft to soft, with a light red to red-brown appearance that darkens with age.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-pinewood.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Pine Wood
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Pine wood is one of the most ubiquitous and least expensive types of wood available. Because of this, some people hold pine wood in low regard. Pine wood varieties are beautiful and diverse, featuring various colors, textures, and wood grains. It is useful as wood in architectural features, foundational building material, and in the creation of by-products like paper.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-tanguile.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Tanguile
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Tanguile (Shorea negrosensis). A tree with a long and cylindrical buttress bole, the tanguile has a reddish-brown wood that is often called Philippine mahogany among other variants. It is a semi-hardwood that is often used as framing, flooring, furniture, and stairs.</p>
									</div>
								</div>
								<div class="flex flex-wrap bg-white w-full pt-4 px-4 lg:p-8 items-center justify-center gap-y-6">
									<div class="w-1/2 lg:w-1/4">
										<img class="" src="@/assets/img/wood-teakwood.jpg" alt="" width="337" height="600">
									</div>
									<div class="w-full lg:w-3/4 lg:p-8 space-y-4 lg:space-y-8">
										<div class="text-2xl lg:text-4xl uppercase font-medium text-center">
											Teak Wood
										</div>
										<p class="text-justify lg:leading-relaxed text-sm lg:text-base">Teak is a tropical hardwood tree species in the family Lamiaceae. It is a large, deciduous tree that occurs in mixed hardwood forests. Tectona grandis has small, fragrant white flowers arranged in dense clusters at the end of the branches. These flowers contain both types of reproductive organs.</p>
									</div>
								</div>

								<template slot="prev">
									<button class="absolute top-1/2 -translate-y-1/2 left-[-55px] w-[55px] h-64 bg-[#202020] hover:bg-gray-700 duration-200 rounded-tl-full rounded-bl-full hidden lg:flex justify-center items-center text-white text-6xl font-oswald font-extralight pb-4">
										&lt;
									</button>
								</template>
								<template slot="next">
									<button class="absolute top-1/2 -translate-y-1/2 right-[-55px] w-[55px] h-64 bg-[#202020] hover:bg-gray-700 duration-200 rounded-tr-full rounded-br-full hidden lg:flex justify-center items-center text-white text-6xl font-oswald font-extralight pb-4">
										&gt;
									</button>
								</template>
							</owl-carousel>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="relative section about-section z-[1]">
			<div class="absolute top-0 left-0 w-full h-full skew-y-6 pointer-events-none">
				<div class="absolute inset-0 bg-[#244D13] overflow-hidden">
					<!-- <div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}"></div> -->
				</div>
			</div>
			<div class="container relative py-16 lg:pb-32">
				<div class="flex gap-8 items-end">
					<div class="flex-1 hidden lg:block">
						<img class="rounded-full" src="@/assets/img/about-img.jpg" alt="" width="960" height="960">
					</div>
					<div class="space-y-8 lg:space-y-12 text-white w-full lg:w-8/12">
						<div class="text-center lg:text-left text-3xl lg:text-5xl lg:leading-tight font-oswald">
							About <span class="font-extralight">Us</span>
						</div>
						<div class="space-y-4 text-justify">
							<p>M.V. Samera Enterprises is a family business headed by Engr. Michael Viola Samera. He founded the company in 2001 out from the learnings and experiences he got from the small wood work business owned by his father.</p>
							<p>M.V. Samera delivers a complete quality service of wooden sash and flooring works that are done systematically by an expert. With over 20 years of expertise, we are fostering the culture of what <strong>MVS</strong> stands for: <strong>Members with Teamwork, Victory belongs to God, and Service with Integrity</strong>. These are the essential core values that motivate our actions excellently while performing the key activities of our company. Employees are motivated that “work is born out of love”, and “work is the manifestation of love and is directed toward love”.</p>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="relative section about-section z-[1]">
			<div class="absolute top-0 left-0 w-full h-full skew-y-6 pointer-events-none">
				<div class="absolute inset-0 overflow-hidden">
					<div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}"></div>
					<div class="absolute inset-0 bottom-[50%] lg:bottom-0 lg:right-[50%] bg-[#E8D71680] X__backdrop-blur-sm"></div>
					<div class="absolute inset-0 top-[50%] lg:top-0 lg:left-[50%] bg-[#20202080] X__backdrop-blur-sm"></div>
				</div>
			</div>
			<div class="container relative pt-8 pb-12 lg:pt-16 lg:pb-32">
				<div class="grid lg:grid-cols-2 gap-x-16 space-y-16">
					<div class="space-y-8 lg:space-y-12">
						<div class="text-3xl lg:text-5xl lg:leading-tight font-oswald">
							Vision
						</div>
						<div class="space-y-4 text-justify">
							<p>To become a company with <strong>culture of excellence</strong> that offers high quality of workmanship. To become one of the most preferred wood sash and flooring contractor in the Philippines.</p>
						</div>
					</div>
					<div class="space-y-8 lg:space-y-12 text-white">
						<div class="text-3xl lg:text-5xl lg:leading-tight font-oswald">
							Mission
						</div>
						<div class="space-y-4 text-justify">
							<p>We aim to deliver high quality products and services as par to international standard, anchored to our core values and culture that seeks to give the client the best possible product.</p>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="relative section contact-section z-[1]">
			<div class="absolute top-0 left-0 right-0 h-full skew-y-6 bg-white pointer-events-none">
				<!-- <div class="absolute top-0 left-0 right-0 h-36 bg-white"></div> -->
			</div>
			<div class="container relative py-8 lg:py-16">
				<div class="grid lg:grid-cols-2 gap-x-16 space-y-16">
					<div class="space-y-12">
						<div class="space-y-4">
							<div class="text-3xl lg:text-5xl lg:leading-tight font-oswald">
								Have a project <span class="font-extralight">in mind?</span>
							</div>
							<div class="text-base lg:text-lg" style="text-wrap: pretty;">
								Send us your plans or project requirements and request a quotation.
							</div>
						</div>
						<div class="space-y-4">
							<div class="space-y-2">
								<div class="font-bold text-xl">Local Address</div>
								<!-- <p>16 Velasquez St., Sitio Bangiad, San Juan, Taytay, Rizal</p> -->
								<p>Please pin <strong>M.V. Samera Enterprise</strong> to your Google maps/Waze.</p>
							</div>
							<div class="space-y-2">
								<div class="font-bold text-xl">Mobile</div>
								<!-- <div>
									<a class="inline-block hover:underline" href="tel:+639171230651">(+63) 917 123 0651</a>
								</div> -->
								<div>
									<a class="inline-block hover:underline" href="tel:+639209080357">(+63) 920 908 0357</a>
								</div>
							</div>
							<div class="space-y-2">
								<div class="font-bold text-xl">Email</div>
								<a class="inline-block hover:underline" href="mailto:mvsamera.pqc@gmail.com">mvsamera.pqc@gmail.com</a>
							</div>
							<!-- <div class="space-x-8 !mt-8">
								<a class="inline-block hover:brightness-150 duration-200" href="https://www.facebook.com/profile.php?id=100090286620317&mibextid=ZbWKwL" target="_blank" rel="nofollow">
									<img src="@/assets/img/icon-fb.png" alt="" width="45" height="45">
								</a>
								<a class="inline-block hover:brightness-150 duration-200" href="https://www.instagram.com/mvsameraenterprises01/?fbclid=IwAR3l1VbZa5_aUphAUyfCPdNHHcfc1Z2aA2kmrHScwgLnI7QUlzXlAPrw_BA" target="_blank" rel="nofollow">
									<img src="@/assets/img/icon-ig.png" alt="" width="45" height="45">
								</a>
								<a class="inline-block hover:brightness-150 duration-200" href="https://twitter.com/MVSamera01?fbclid=IwAR3dr7cLD-8IVhBiXAJDRsP0NX9g7lqSzXjTT9g1BumFPyTgWaT7BjpgS5U" target="_blank" rel="nofollow">
									<img src="@/assets/img/icon-tw.png" alt="" width="45" height="45">
								</a>
							</div> -->
						</div>
					</div>

					<div id="inquiry" class="space-y-12">
						<ContactForm />
					</div>
				</div>
			</div>
		</section>


		<section id="faqs" class="relative section about-section z-[0] bg-[#E8DD7A]">
			<div class="absolute top-0 left-0 w-full h-36 skew-y-6 pointer-events-none">
				<div class="absolute inset-0 bg-[#E8DD7A] overflow-hidden">
					<!-- <div class="absolute inset-0 -skew-y-6 -top-64 -bottom-64 wood-bg" :style="{backgroundPosition: `center ${winScrollY.woods}px`}"></div> -->
				</div>
			</div>
			<div class="container relative py-16 lg:pb-32">
				<div class="space-y-8 lg:space-y-12">
					<div class="text-center lg:text-left text-3xl lg:text-5xl lg:leading-tight font-oswald">
						Frequently Asked <span class="font-extralight">Questions</span>
					</div>
					<div class="flex flex-col md:flex-row gap-8 lg:gap-12">
						<!-- Side Tabs Navigation (Sticky Horizontal Scroll on Mobile) -->
						<div class="w-full md:w-64 flex-shrink-0">
							<!-- Sticky container: sticks to top on mobile, and sticks to top-24 on desktop (adjust top value to clear any main site navbars) -->
							<div class="sticky top-0 md:top-24 z-10 bg-[#E8DD7A] md:bg-transparent py-4 md:py-0 border-b border-gray-400/30 md:border-b-0">
								<ul class="flex md:flex-col overflow-x-auto overflow-y-hidden md:overflow-visible whitespace-nowrap md:whitespace-normal gap-2 md:gap-4 scrollbar-hide pb-4 md:pb-0">
									<li v-for="(group, index) in faqGroups" :key="index">
										<button
											@click="activeCategory = index"
											:class="[
												'block px-5 py-3 text-left w-full font-bold transition-all duration-300',
												activeCategory === index
													? 'bg-black text-white shadow-md'
													: 'hover:bg-black/10 text-black'
											]"
										>
											{{ group.category }}
										</button>
									</li>
								</ul>
							</div>
						</div>
						<!-- FAQ Content List -->
						<div class="flex-1 w-full">
							<div class="space-y-4">
								<!-- Optional category header for desktop view to reinforce context -->
								<div class="font-bold text-2xl mb-6 hidden md:block">
									{{ faqGroups[activeCategory].category }}
								</div>

								<DynamicDropdown
									v-for="faq in faqGroups[activeCategory].items"
									:key="faq.id"
									:question="faq.question"
									:is-open="activeFaqIndex === faq.id"
									@toggle="toggleFaq(faq.id)"
								>
									<div class="space-y-4" v-html="faq.answer"></div>
								</DynamicDropdown>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<!-- <SiteFooter /> -->


	</div>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
// import MenuItem from '@/components/MenuItem.vue'
// import SiteFooter from '@/components/SiteFooter.vue'
import ContactForm from '@/components/ContactForm.vue'
import DynamicDropdown from '@/components/Dropdown.vue';

export default {
	name: 'index-page',
	components: {
		SiteHeader,
		// MenuItem,
		// SiteFooter,
		ContactForm,
		DynamicDropdown,
	},
	data() {
		return {
			isOpen: 0,
			isTop: true,
			winScrollY: {
				global: 0,
				woods: 0,
			},
			// Tracks the index of the single open FAQ. null means all are closed.
			activeFaqIndex: null,
			activeCategory: 0,
			faqGroups: [
				{
					category: 'General',
					items: [
						{
							id: 1,
							question: 'What does MV Samera Enterprises specialize in?',
							answer: `
								<p>MV Samera Enterprises specializes in the supply, manufacturing, fabrication, finishing, and installation of wood and wood-related architectural products for residential, condominium, commercial, hospitality, and other construction projects.</p>
								<p>Our services and products include:</p>
								<ul class="list-disc">
									<li class="ml-6">Solid wood doors</li>
									<li class="ml-6">Door jambs, casings, and trims</li>
									<li class="ml-6">Solid wood and engineered wood flooring</li>
									<li class="ml-6">Baseboards, cornices, and mouldings</li>
									<li class="ml-6">Stair treads, handrails, and other stair components</li>
									<li class="ml-6">Wall and ceiling wood cladding</li>
									<li class="ml-6">Veneered panels</li>
									<li class="ml-6">Acoustic wood slats wall panels</li>
									<li class="ml-6">Exterior wood decking</li>
									<li class="ml-6">SPC and LVT flooring</li>
									<li class="ml-6">Customized architectural woodworks</li>
									<li class="ml-6">On-site carpentry and installation</li>
								</ul>`
						},
						{
							id: 2,
							question: 'How long has MV Samera Enterprises been in business?',
							answer: `<p>MV Samera Enterprises has been serving the construction and woodworking industry since 2002, providing customized wood products and installation services for various types of projects.</p>`
						},
						{
							id: 3,
							question: 'Do you manufacture your own wood products?',
							answer: `<p>Yes. Many of our wood products are manufactured and fabricated according to the specifications and requirements of each project. This allows us to provide better control over dimensions, wood selection, fabrication, finishing, quality, and project requirements.</p>`
						},
					],
				},
				{
					category: 'Products & Materials',
					items: [
						{
							id: 4,
							question: 'What types of wood do you offer?',
							answer: `
								<p>Wood species may vary depending on availability and project specifications. Options can include:</p>
								<ul class="list-disc">
									<li class="ml-6">Tanguile</li>
									<li class="ml-6">Narra</li>
									<li class="ml-6">Teak</li>
									<li class="ml-6">Oak</li>
									<li class="ml-6">European Oak</li>
									<li class="ml-6">Walnut</li>
									<li class="ml-6">Acacia</li>
									<li class="ml-6">African Mahogany</li>
									<li class="ml-6">Merbau</li>
									<li class="ml-6">Okoume</li>
									<li class="ml-6">Other imported and locally available wood species</li>
								</ul>
								<p>Our team can recommend an appropriate species based on the intended application, appearance, budget, durability requirements, and availability.</p>`
						},
						{
							id: 5,
							question: 'Do you offer both solid wood and engineered wood?',
							answer: `<p>Yes. Depending on the application and project requirements, we can provide solid wood, engineered wood, veneered products, and selected alternative flooring and architectural materials.</p>`
						},
						{
							id: 6,
							question: 'Can you manufacture customized sizes and designs?',
							answer: `
								<p>Yes. Customized manufacturing is one of our core capabilities.</p>
								<p>We can work according to approved:</p>
								<ul class="list-disc">
									<li class="ml-6">Architectural drawings</li>
									<li class="ml-6">Interior design drawings</li>
									<li class="ml-6">Shop drawings</li>
									<li class="ml-6">Specifications</li>
									<li class="ml-6">Actual site measurements</li>
									<li class="ml-6">Approved samples</li>
								</ul>
								<p>Final feasibility will depend on the design, material availability, dimensions, quantity, and technical requirements.</p>`
						},
						{
							id: 7,
							question: 'Can you match an existing wood color or finish?',
							answer: `
								<p>We can develop finishes based on an approved reference or sample.</p>
								<p>Because wood is a natural material, variations in grain, tone, texture, and color should be expected. We therefore recommend establishing an approved finish sample before full production whenever applicable.</p>`
						},
					],
				},
				{
					category: 'Quotations & Inquiries',
					items: [
						{
							id: 8,
							question: 'How can I request a quotation?',
							answer: `
								<p>You may send us your project information through our website inquiry form, email, or authorized sales representative.</p>
								<p>For a more accurate quotation, please fill-out the form above. The more complete the information, the more accurately our estimating team can evaluate your requirements.</p>`
						},
						{
							id: 9,
							question: 'Can I send architectural drawings or plans for quotation?',
							answer: `
								<p>Yes. We encourage architects, designers, contractors, developers, and property owners to provide relevant drawings and specifications.</p>
								<p>Our estimating team can review the available information and identify the items relevant to our scope of work.</p>`
						},
						{
							id: 10,
							question: 'Do you provide site measurements?',
							answer: `
								<p>Site measurement or verification may be arranged when necessary, particularly for projects requiring customized fabrication or installation.</p>
								<p>Availability and possible charges will depend on the project's location, size, and stage of development.</p>`
						},
						{
							id: 11,
							question: 'Do you provide free quotations?',
							answer: `<p>Initial quotations may generally be prepared based on sufficiently detailed information supplied by the client. However, specialized services such as extensive site surveys, detailed technical studies, multiple design revisions, samples, mock-ups, or other pre-construction work may be subject to separate arrangements.</p>`
						},
					],
				},
				{
					category: 'Pricing',
					items: [
						{
							id: 12,
							question: 'How much do your wood products cost?',
							answer: `
								<p>Pricing varies according to:</p>
								<ul class="list-disc">
									<li class="ml-6">Wood species</li>
									<li class="ml-6">Grade and quality</li>
									<li class="ml-6">Product dimensions</li>
									<li class="ml-6">Quantity</li>
									<li class="ml-6">Design complexity</li>
									<li class="ml-6">Required finish</li>
									<li class="ml-6">Hardware and accessories</li>
									<li class="ml-6">Installation requirements</li>
									<li class="ml-6">Project location</li>
									<li class="ml-6">Site conditions</li>
									<li class="ml-6">Delivery requirements</li>
								</ul>
								<p>For this reason, customized projects are normally priced after reviewing the specifications rather than using a single standard price.</p>`
						},
						{
							id: 13,
							question: 'Do you offer contractor, developer, or volume pricing?',
							answer: `
								<p>Volume or project-based pricing may be available for qualified projects.</p>
								<p>We welcome inquiries from:</p>
								<ul class="list-disc">
									<li class="ml-6">Architects</li>
									<li class="ml-6">Interior designers</li>
									<li class="ml-6">General contractors</li>
									<li class="ml-6">Developers</li>
									<li class="ml-6">Construction companies</li>
									<li class="ml-6">Hotels and hospitality companies</li>
									<li class="ml-6">Property managers</li>
									<li class="ml-6">Corporate clients</li>
									<li class="ml-6">Dealers and other industry partners</li>
								</ul>
								<p>Please contact our sales team to discuss your requirements.</p>`
						},
					],
				},
				{
					category: 'Installation',
					items: [
						{
							id: 14,
							question: 'Do you provide installation?',
							answer: `<p>Yes. Depending on the product and project location, MV Samera Enterprises can provide supply-and-installation packages as well as supply-only arrangements.</p>`
						},
						{
							id: 15,
							question: 'Can I purchase materials without installation?',
							answer: `<p>Yes. Selected products can be supplied on a supply-only basis, subject to the product specifications and project requirements.</p>`
						},
						{
							id: 16,
							question: 'Do you accept condominium projects?',
							answer: `
								<p>Yes. We can work on condominium projects, subject to the building's rules, working-hour restrictions, permits, delivery procedures, elevator schedules, and other property-management requirements.</p>
								<p>Clients should inform us of these requirements during quotation and scheduling.</p>`
						},
						{
							id: 17,
							question: 'Do you accept commercial and large-scale projects?',
							answer: `<p>Yes. We can evaluate residential, commercial, institutional, hospitality, condominium, and larger construction projects based on their scope, specifications, quantity, location, and schedule.</p>`
						},
					],
				},
				{
					category: 'Project Process',
					items: [
						{
							id: 18,
							question: 'What is your typical project process?',
							answer: `
								<p>A typical project may follow these stages:</p>
								<p>Inquiry → Requirements Review → Estimation → Quotation → Technical Clarification → Site Verification → Material/Finish Approval → Purchase Order or Contract → Production → Quality Inspection → Delivery → Installation → Turnover</p>
								<p>The exact process may vary depending on the project.</p>`
						},
						{
							id: 19,
							question: 'How long does production take?',
							answer: `
								<p>Lead time depends on the product, quantity, wood species, finish, complexity, material availability, and current production schedule.</p>
								<p>A project-specific production and delivery schedule can be established after the scope and specifications have been finalized.</p>`
						},
						{
							id: 20,
							question: 'Can you accommodate urgent projects?',
							answer: `
								<p>Urgent requirements can be evaluated on a case-by-case basis.</p>
								<p>Acceptance will depend on material availability, manufacturing capacity, installation requirements, and the requested completion date. We recommend contacting our team as early as possible.</p>`
						},
					],
				},
				{
					category: 'Quality & Natural Wood',
					items: [
						{
							id: 21,
							question: 'Why does natural wood sometimes vary in color and grain?',
							answer: `
								<p>Wood is a natural material. Variations in grain, texture, knots, mineral streaks, and color are normal characteristics rather than necessarily manufacturing defects.</p>
								<p>These natural variations are part of what gives genuine wood its unique appearance.</p>`
						},
						{
							id: 22,
							question: 'How do you maintain product quality?',
							answer: `<p>Quality control is incorporated into the manufacturing and project process, including appropriate inspection of materials, dimensions, fabrication, sanding, finishing, and completed products according to the applicable project requirements.</p>`
						},
						{
							id: 23,
							question: 'How should wood flooring and other wood products be maintained?',
							answer: `
								<p>Maintenance depends on the species, finish, environment, and application.</p>
								<p>Generally, clients should:</p>
								<ul class="list-disc">
									<li class="ml-6">Avoid prolonged exposure to standing water.</li>
									<li class="ml-6">Maintain appropriate indoor humidity and ventilation.</li>
									<li class="ml-6">Clean using products suitable for the particular wood finish.</li>
									<li class="ml-6">Avoid harsh chemicals unless approved for the finish.</li>
									<li class="ml-6">Protect flooring from excessive scratching and impact.</li>
									<li class="ml-6">Address water leaks and moisture problems immediately.</li>
									<li class="ml-6">Specific care instructions may be provided depending on the product.</li>
								</ul>`
						},
					],
				},
				{
					category: 'Architects, Designers & Contractors',
					items: [
						{
							id: 24,
							question: 'Can MV Samera Enterprises work directly with my architect or interior designer?',
							answer: `<p>Yes. We can coordinate with architects, interior designers, contractors, project managers, and other authorized project representatives regarding technical specifications, materials, dimensions, samples, and installation requirements.</p>`
						},
						{
							id: 25,
							question: 'Can you provide material or finish samples?',
							answer: `
								<p>Samples may be prepared or submitted when required, subject to material availability, project requirements, quantity, and applicable sample charges.</p>
								<p>For customized finishes, we recommend obtaining client approval of the sample before proceeding with full production.</p>`
						},
						{
							id: 26,
							question: 'Can you prepare shop drawings?',
							answer: `<p>Shop drawings or technical details may be provided for selected scopes when required by the project and agreed upon as part of our services.</p>`
						},
					],
				},
				{
					category: 'Delivery & Service Areas',
					items: [
						{
							id: 27,
							question: 'What areas do you serve?',
							answer: `
								<p>MV Samera Enterprises primarily serves projects within Metro Manila, Rizal, Laguna, Cavite, and other areas of Luzon, while projects in other locations may be evaluated depending on their size, logistics, and requirements.</p>
								<p>Contact us with your project location so our team can determine how we can serve you.</p>`
						},
						{
							id: 28,
							question: 'Do you deliver to project sites?',
							answer: `
								<p>Yes. Delivery can be arranged depending on the product, quantity, accessibility, project location, and site requirements.</p>
								<p>Delivery conditions and charges, when applicable, will be indicated or discussed during quotation.</p>`
						},
					],
				},
				{
					category: 'Warranty & After-Sales',
					items: [
						{
							id: 29,
							question: 'Do your products come with a warranty?',
							answer: `
								<p>Applicable warranty coverage depends on the specific product, scope of work, contract, installation conditions, and agreed terms.</p>
								<p>Warranty conditions should be reviewed together with the formal quotation or contract.</p>`
						},
						{
							id: 30,
							question: 'What should I do if I have an issue after installation?',
							answer: `
								<p>Please contact our team and provide:</p>
								<ul class="list-disc">
									<li class="ml-6">Project name</li>
									<li class="ml-6">Location</li>
									<li class="ml-6">Product involved</li>
									<li class="ml-6">Description of the concern</li>
									<li class="ml-6">Photos or videos</li>
									<li class="ml-6">Date the issue was observed</li>
									<li class="ml-6">Our team can review the concern and determine the appropriate next action.</li>
								</ul>`
						},
					],
				},
				{
					category: 'Starting A Project',
					items: [
						{
							id: 31,
							question: 'I am not sure what type of wood or product I need. Can you help?',
							answer: `
								<p>Yes. Tell us about the intended application, preferred appearance, location, expected usage, budget range, and project requirements.</p>
								<p>Our team can recommend suitable options for your consideration.</p>`
						},
						{
							id: 32,
							question: 'What information should I prepare before contacting you?',
							answer: `<p>For faster evaluation, fill out as much information in the form above.</p>`
						},
						{
							id: 33,
							question: 'How do I start my project with MV Samera Enterprises?',
							answer: `
								<p>Send us your plans, specifications, quantities, project location, and target schedule.</p>
								<p>Our team can review your requirements and guide you through the next steps toward quotation, material selection, production, delivery, and installation.</p>`
						},
					],
				},
			],
		}
	},
	mounted () {
		// window.addEventListener('scroll', this.handleScroll, {passive: true});
		window.addEventListener('scroll', this.handleScroll, {passive: true});
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			this.isTop = window.scrollY < 200;
			this.winScrollY.global = window.scrollY / 1.5;
			this.winScrollY.banner = 128 + (window.scrollY / 1.5);
			this.winScrollY.woods = window.scrollY / 2;
			// this.winScrollY.about = document.getElementById("myElement").offsetTop + (window.scrollY / 1.125);
		},
		toggleFaq(index) {
			// If the clicked FAQ is already open, close it (set to null).
			// Otherwise, open the clicked FAQ (and close the previous one automatically).
			this.activeFaqIndex = this.activeFaqIndex === index ? null : index;
		}
	},
}
</script>

<style>
/* #mainpage {
	background-image: url('~@/assets/img/bg01.jpg');
	@apply bg-cover bg-center bg-no-repeat bg-fixed;
} */
.wood-bg {
	background-image: url('~@/assets/img/wood-bg.jpg');
	@apply bg-center;
}
.wood-bg-2 {
	background-image: url('~@/assets/img/wood-bg-2.jpg');
	@apply bg-cover bg-center bg-no-repeat;
}
.wood-bg-3 {
	background-image: url('~@/assets/img/wood-bg-2.jpg');
	@apply bg-cover bg-center bg-no-repeat;
}

.woods-slider>[id^="carousel_prev"] {
	display: block !important;
}
.parallax {
	-webkit-perspective: 1px;
	perspective: 1px;
}
.parallax-bg {
	/* @apply inset-0; */
	/* transform: translate(-50%, -50%); */
	-webkit-transform-style: preserve-3d;
	transform-style: preserve-3d;
	-webkit-transform: translateZ(-1px) scale(2);
	transform: translateZ(-1px) scale(2);
	/* bottom: -200%; */
	/* background-image: url('@/assets/img/wood-bg.jpg'); */
}
.banner-section {
	/* background-image: url('~@/assets/img/buybanner.jpg');
	@apply bg-cover bg-top bg-no-repeat; */
}
@screen lg {
	.banner-section {
		/* aspect-ratio: 5/2; */
	}
}
</style>
